import React, { useEffect } from "react";
import trans from "../../../../utils";
import { Switch } from "antd";
import { Input } from "../../../Helpers/Input/Input";
import { QuestionCircleOutlined } from "@ant-design/icons";

export default function POIsGeo({ setDiameter, active, setActive, addPOI }) {
	const onChange = (checked) => {
		setActive(checked);
		addPOI.setFieldValue("geofenced", checked);
	};
	useEffect(() => {
		if (!addPOI.values.geofenced) {
			setDiameter(null);
			addPOI.setFieldValue("diameter", null);
			addPOI.setFieldValue("area", null);
			addPOI.setFieldValue("address", null);
		}
	}, [addPOI.values.geofenced]);
	return (
		<>
			<p className="fs-16 fw-500 brand-700 text-capitalize">
				{trans("geofencing configuration")}
			</p>
			<div className="poi-geofence-config">
				<div className="flex-between">
					<div>
						<div className="poi-geofence-config-head">
							{trans("enable geofence")}
						</div>
						<div className="poi-geofence-config-title">
							{trans(
								"Automatically detect when field staff enter or exit this POI area"
							)}
						</div>
					</div>
					<Switch
						id="geofenced"
						name="geofenced"
						checked={addPOI?.values?.geofenced || false} // ✅ should use checked, not value
						onChange={onChange}
					/>
				</div>

				{addPOI.values.geofenced && (
					<div className="pois-geofence">
						<div className="col-lg-12">
							<Input
								title={trans("Distance (meters)")}
								type="number"
								max={1000}
								min={50}
								placeholder={trans("Enter distance")}
								id="diameter"
								name="diameter"
								formstyle="form-input"
								onChange={(e) => {
									addPOI.handleChange(e);
									setDiameter(e.target.value);
								}}
								onBlur={(e) => addPOI.handleBlur(e)}
								errors={addPOI.errors.diameter}
								touched={addPOI.touched.diameter}
								value={addPOI.values.diameter || ""}
								onKeyDown={(e) => {
									if (["e", "E", "+", "-"].includes(e.key)) {
										e.preventDefault();
									}
								}}
							/>
						</div>
						<p
							style={{
								color: "#647188",
								fontSize: "14px",
								marginTop: "6px",
								marginBottom: "10px",
							}}
						>
							{trans("Min 50m - Max 1000m")}
						</p>
						<div className="poi-geofence-hint">
							<QuestionCircleOutlined />
							<div style={{ width: "95%" }}>
								{trans(
									"Field staff with mobile apps will automatically log attendance and trigger task updates when entering or exiting."
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
}
